import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { Profile } from '../profile.model';
import { ProfileService } from '../profile.service';

@Component({
    selector: 'delete-topic',
    templateUrl: './delete-topic-dialog.component.html',
    styleUrls: [
        './delete-topic-dialog.component.css'
    ]
})
export class DeleteTopicDialogComponent implements OnInit {

    // Properties
    information: Profile;
    deleted: boolean;

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<DeleteTopicDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private profileService: ProfileService
    ) { }

    // Event Functions
    ngOnInit() {
        // POST: initializes the data
        this.information = this.data.information;
    }

    delete() {
        // PRE: the delete button is clicked
        // POST: deletes the information from the server, sets deleted to true, and closes the dialog box
        this.information.DelStatus = true;
        this.profileService.updateProfile(this.information).subscribe(() => {
            this.deleted = true;
            this.dialogBox.close();
        });
    }

    cancel() {
        // PRE: the close button is clicked
        // POTS: sets deleted to false and closes the dialog box
        this.deleted = false;
        this.dialogBox.close();
    }

    // Methods
}